const timetableArr = [
  {
    content: "",
    type: "empty",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Пн",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Вт",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Ср",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Чт",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Пт",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Сб",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Вс",
    type: "day",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "17:00",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "17:30",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "18:00",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 4-6 лет",
    type: "square",
    class: "blue",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 4-6 лет",
    type: "square",
    class: "blue",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "18:30",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 4-6 лет",
    type: "square",
    class: "blue",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 4-6 лет",
    type: "square",
    class: "blue",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "19:00",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 7 лет и ст.",
    type: "square",
    class: "green",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 7 лет и ст.",
    type: "square",
    class: "green",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "19:30",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 7 лет и ст.",
    type: "square",
    class: "green",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 7 лет и ст.",
    type: "square",
    class: "green",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "21:00",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 7 лет и ст.",
    type: "square",
    class: "green",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "Дети 7 лет и ст.",
    type: "square",
    class: "green",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "21:30",
    type: "time",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
  {
    content: "",
    type: "square",
    class: "",
    pseudoContent: "",
    pseudoClass: "",
  },
];

timetableArr.forEach((el) => {
  if (el.type === "empty")
    $(".timetable").append(`<div class="timetable__empty"></div>`);
  if (el.type === "day")
    $(".timetable").append(`<div class="timetable__day">${el.content}</div>`);
  if (el.type === "time")
    $(".timetable").append(`<div class="timetable__time">${el.content}</div>`);
  if (el.type === "square")
    $(".timetable").append(
      `<div class="timetable__square${el.content !== "" ? " content" : ""}">
            <div class="timetable__square-item">
                ${el.content !== "" ? `<div class="${el.class}"></div>` : ""}
                <p>${el.content}</p>
            </div>
            ${
              el.pseudoContent !== ""
                ? `<div class="timetable__square-item">
                ${
                  el.pseudoContent !== ""
                    ? `<div class="${el.pseudoClass}"></div>`
                    : ""
                }
                <p>${el.pseudoContent}</p>
            </div>`
                : ""
            }
        </div>`
    );
});
